import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  * {
    font-family: "Avenir", sans-serif;
  }

  html,
  body {
    min-width: auto;
  }
`
